import React, { useEffect, useState, useRef } from "react";
import "./user.css";
import { CiEdit } from "react-icons/ci";
import { MdRemoveRedEye } from "react-icons/md";
import {
  disablePayinPayout,
  fetchAllProviders,
  getAlllRoles,
  getAllUsers,
  UpdateAutoSwitch,
  updateUser,
  UpdateAutoSwitchPayout,
  updateIpWhitelistStatus,
  updateUserStatus,
  updateVpaStatus,
} from "../../config/LiveApi";
import Prompt from "../../components/common/Prompt";
import { toast } from "react-toastify";
import Modal from "./Modal";
import ViewModal from "./ViewModal";
import { Switch } from "@mui/material";
import { useSelector } from "react-redux";
import ConfirmModal from "./ConfirmaModal";
import { FaFilter } from "react-icons/fa";

function UserManageTable({
  isLoading,
  tableData,
  setTableData,
  onUpdateTableData,
  fetchUsers,
  payinChecked,
  payoutChecked,
  setPayinChecked,
  setPayoutChecked,
}) {
  const [isEnableUserPromptOpen, setIsEnableUserPromptOpen] = useState(false);
  const [isDisableUserPromptOpen, setIsDisableUserPromptOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [formData, setFormData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disableAllUserPayinPrompt, setDisableAllUserPayinPrompt] =
    useState(false);
  const [enableAllUserPayinPrompt, setEnableAllUserPayinPrompt] =
    useState(false);
  const [disableAllUserPayoutPrompt, setDisableAllUserPayoutPrompt] =
    useState(false);
  const [enableAllUserPayoutPrompt, setEnableAllUserPayoutPrompt] =
    useState(false);
  const [disableAllUsersPrompt, setDisableAllUsersPrompt] = useState(false);
  const [enableAllUsersPrompt, setEnableAllUsersPrompt] = useState(false);
  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);
  const currentUserId = useSelector((store) => store.userReducer.userId);
  const [providerOptions, setProviderOptions] = useState([]);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmText, setConfirmText] = useState("");
  const [roles, setRoles] = useState(false);
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("All");

  // Infinite scroll states
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const tableDivRef = useRef(null);

  // Fetch paginated users
  const fetchMoreUsers = async (pageNum, reset = false) => {
    setIsFetching(true);
    try {
      // Replace with your actual API endpoint and token if needed
      const response = await getAllUsers(token, pageNum);
      const result = response;
      if (result.data && result.data.length > 0) {
        setTableData((prev) => [...prev, ...result.data]);
        setHasMore(
          result.meta.pagination.page < result.meta.pagination.totalPages,
        );
      } else {
        setHasMore(false);
      }
    } catch (err) {
      setHasMore(false);
    }
    setIsFetching(false);
  };

  // Scroll handler
  const handleScroll = () => {
    const div = tableDivRef.current;
    if (!div || isFetching || !hasMore) return;
    if (div.scrollTop + div.clientHeight >= div.scrollHeight - 100) {
      setPage((prev) => prev + 1);
    }
  };

  // Attach scroll event
  useEffect(() => {
    const div = tableDivRef.current;
    if (!div) return;
    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore]);

  // Fetch more users when page changes
  useEffect(() => {
    if (page === 1 || role === "admin" || role === "subAdmin") return;
    fetchMoreUsers(page);
    // eslint-disable-next-line
  }, [page]);

  // Reset infinite scroll on filter/role change
  useEffect(() => {
    setPage(1);
    setHasMore(true);
  }, [selectedRoleName]);

  const handleConfirmModal = (text, action) => {
    setConfirmText(text);
    setConfirmAction(() => action);
    setConfirmModalOpen(true);
  };

  const confirmAndClose = () => {
    if (confirmAction) confirmAction();
    setConfirmModalOpen(false);
  };

  const handleDisableAction = async (currentUser, fetchUsers) => {
    try {
      // await patch(`/v1/admin/users/${currentUser?.id}`, {
      //   status: currentUser.status,
      // });
      // onUpdateTableData((prevTableData) =>
      //   prevTableData.map((user) =>
      //     user.id === currentUser.id ? { ...user, ...formData } : user
      //   )
      // );
      // let action = "";
      // if (currentUser.status === 0) action = "User disabled";
      // if (currentUser.status === 2) action = "Payin disabled";
      // if (currentUser.status === 3) action = "Payout disabled";
      // toast.success(`${action} successfully.`);
      // setIsDisableUserPromptOpen(false);
      // fetchUsers();
    } catch (error) {
      console.log(error.message);
      toast.error("Unable to perform the action. Please try again.");
    }
  };

  const handleEnableAction = async (currentUser, fetchUsers) => {
    try {
      // await patch(`/v1/admin/users/${currentUser?.id}`, { status: 1 });
      // onUpdateTableData((prevTableData) =>
      //   prevTableData.map((user) =>
      //     user.id === currentUser.id ? { ...user, ...formData } : user
      //   )
      // );
      // let action = "";
      // if (currentUser.status === 0) action = "User enabled";
      // if (currentUser.status === 2) action = "Payin enabled";
      // if (currentUser.status === 3) action = "Payout enabled";
      // toast.success(`${action} successfully.`);
      // setIsEnableUserPromptOpen(false);
      // fetchUsers();
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleUpdateSubmit = async (updatedFormData, currentUser) => {
    event.preventDefault();

    try {
      await updateUser(token, updatedFormData);

      onUpdateTableData((prevTableData) =>
        prevTableData.map((user) =>
          user.id === currentUser.id ? { ...user, ...updatedFormData } : user,
        ),
      );

      toast.success("User updated successfully.");
      setIsModalOpen(false);
    } catch (error) {
      console.log(error.message);
      toast.error("Not able to update user. Please try again.");
    }
  };

  const updateFunction = (item, setFormData) => {
    setFormData(item);
    setIsModalOpen(true);
  };

  const viewFunction = (item, setFormData, setIsModalOpen) => {
    setFormData(item);
    setIsViewModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsViewModalOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleAllPayin = async (event) => {
    if (event.target.value == 1) setDisableAllUserPayinPrompt(true);
    else setEnableAllUserPayinPrompt(true);
  };

  const handleAllPayout = async (event) => {
    if (event.target.value == 1) setDisableAllUserPayoutPrompt(true);
    else setEnableAllUserPayoutPrompt(true);
  };

  const handleEnableAllPayinAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYIN",
      action: "ENABLE",
    });

    setEnableAllUserPayinPrompt(false);
    setPayinChecked(!payinChecked);
  };

  const handleDisableAllPayinAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYIN",
      action: "DISABLE",
    });

    setDisableAllUserPayinPrompt(false);
    setPayinChecked(!payinChecked);
  };

  const handleEnableAllPayoutAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYOUT",
      action: "ENABLE",
    });

    setEnableAllUserPayoutPrompt(false);
    setPayoutChecked(!payoutChecked);
  };

  const handleDisableAllPayoutAction = async () => {
    await disablePayinPayout(token, {
      type: "PAYOUT",
      action: "DISABLE",
    });

    setDisableAllUserPayoutPrompt(false);
    setPayoutChecked(!payoutChecked);
  };

  const handleEnableAllAction = async () => {
    try {
      await disablePayinPayout(token, {
        status: 1,
      });
    } catch (err) {
      console.log(err.message);
      throw err;
    }

    setEnableAllUsersPrompt(false);
    // setUserChecked(!userChecked);
  };

  const handleDisableAllAction = async () => {
    try {
      await disablePayinPayout(token, {
        status: 0,
      });
    } catch (err) {
      console.log(err.message);
      throw err;
    }

    setDisableAllUsersPrompt(false);
    // setUserChecked(!userChecked);
  };

  const handlePayinChange = async (item) => {
    if (item.status === 0) {
      toast.info("User is diabled.");
      return;
    }
    let updatedStatus;

    if (item.status === 1) {
      // Active → disable payin
      updateUserStatus(token, item, 2);
      updatedStatus = 2;
      toast.success(`Payin disabled successfully.`);
    } else if (item.status === 2) {
      // Payin disabled → back to active
      updateUserStatus(token, item, 1);
      updatedStatus = 1;
      toast.success(`Payin enabled successfully.`);
    } else if (item.status === 3) {
      // Payout disabled → disable payin too → both off but user enabled
      updateUserStatus(token, item, 4);
      updatedStatus = 4;
      toast.success(`Both Payin & Payout disabled successfully.`);
    } else if (item.status === 4) {
      // Both disabled → re-enable payin (payout still disabled)
      updateUserStatus(token, item, 3);
      updatedStatus = 3;
      toast.success(`Payin enabled successfully.`);
    }

    setTableData((prevData) =>
      prevData.map((i) =>
        i.id === item.id ? { ...i, status: updatedStatus } : i,
      ),
    );
  };

  const handlePayoutChange = (item) => {
    if (item.status === 0) {
      toast.info("User is diabled.");
      return;
    }
    let updatedStatus;

    if (item.status === 1) {
      // Active → disable payout
      updateUserStatus(token, item, 3);
      updatedStatus = 3;
      toast.success(`Payout disabled successfully.`);
    } else if (item.status === 3) {
      // Payout disabled → back to active
      updateUserStatus(token, item, 1);
      updatedStatus = 1;
      toast.success(`Payout enabled successfully.`);
    } else if (item.status === 2) {
      // Payin disabled → disable payout too → both off but user enabled
      updateUserStatus(token, item, 4);
      updatedStatus = 4;
      toast.success(`Both Payin & Payout disabled successfully.`);
    } else if (item.status === 4) {
      // Both disabled → re-enable payout (payin still disabled)
      updateUserStatus(token, item, 2);
      updatedStatus = 2;
      toast.success(`Payout enabled successfully.`);
    }

    setTableData((prevData) =>
      prevData.map((i) =>
        i.id === item.id ? { ...i, status: updatedStatus } : i,
      ),
    );
  };

  const handleUserChange = (item) => {
    if (item.role === "super") {
      toast.warning("Super user cannot be disabled");
      return;
    } else if (item.id === currentUserId) {
      toast.warning("Current user cannot be disabled");
      return;
    }

    let updatedStatus;

    if (item.status === 0) {
      updateUserStatus(token, item, 4);
      updatedStatus = 4;
      toast.success(`User enabled successfully.`);
    } else {
      updateUserStatus(token, item, 0);
      updatedStatus = 0;
      toast.success(`User disabled successfully.`);
    }

    setTableData((prevData) =>
      prevData.map((i) =>
        i.id === item.id ? { ...i, status: updatedStatus } : i,
      ),
    );
  };

  useEffect(() => {
    if (role == "super" || role == "operation" || role == "subSuper") {
      const getProviders = async () => {
        const response = await fetchAllProviders(token);
        setProviderOptions(response.data.providers);
      };

      getProviders();
    }
  }, []);

  useEffect(() => {
    if (role == "super" || role == "operation" || role == "subSuper") {
      const fetchRoles = async () => {
        try {
          const response = await getAlllRoles(token);
          const roleData = response.data;
          setRoleOptions(roleData);
        } catch (err) {
          toast.error("Unable to fetch.");
        }
      };
      fetchRoles();
    }
  }, [token]);

  const filteredItems =
    tableData?.filter((item) => {
      const matchesRoleName =
        selectedRoleName === "All" || !selectedRoleName
          ? true
          : item.role === selectedRoleName;

      return matchesRoleName;
    }) ?? [];

  const handleVPAChange = (item) => {
    try {
      updateVpaStatus(token, item, !item.validateVpa);
      location.reload();
      toast.success("VPA Validation changed successfully.");
    } catch (err) {
      toast.error("VPA Validation could not be changed.");
      console.error(err.message);
    }
  };

  const handleIPWhitelisting = (item) => {
    try {
      updateIpWhitelistStatus(token, item, !item.ipRequired);
      location.reload();
      toast.success("IP whitelisting status changed successfully.");
    } catch (err) {
      toast.error("IP whitelisting status could not be changed.");
      console.error(err.message);
    }
  };

  const handleAutoSwitch = (item) => {
    try {
      const updatedAutoSwitch = !item.autoSwitch;
      const payload = {
        id: item.id,
        autoSwitch: updatedAutoSwitch,
      };
      UpdateAutoSwitch(token, payload);
      setTableData((prevData) =>
        prevData.map((user) =>
          user.id === item.id
            ? { ...user, autoSwitch: updatedAutoSwitch }
            : user,
        ),
      );
      if (updatedAutoSwitch) {
        toast.success(
          `Auto Switch Enable for User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`,
        );
      } else {
        toast.success(
          `Auto Switch Disable for  User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`,
        );
      }
    } catch (err) {
      toast.error("Auto Switch could not be changed.");
      console.error(err.message);
    }
  };
  const handleAutoSwitchPayout = (item) => {
    try {
      const updatedAutoSwitch = !item.autoSwitchPayout;
      const payload = {
        id: item.id,
        autoSwitchPayout: updatedAutoSwitch,
      };
      UpdateAutoSwitchPayout(token, payload);
      setTableData((prevData) =>
        prevData.map((user) =>
          user.id === item.id
            ? { ...user, autoSwitchPayout: updatedAutoSwitch }
            : user,
        ),
      );
      if (updatedAutoSwitch) {
        toast.success(
          `Auto Switch Payout Enable for User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`,
        );
      } else {
        toast.success(
          `Auto Switch Payout Disable for  User ${
            item.role === "admin"
              ? item.alias || item.id
              : item.alias || item.name
          }.`,
        );
      }
    } catch (err) {
      toast.error("Auto Switch Payout could not be changed.");
      console.error(err.message);
    }
  };

  const rolePriority = {
    super: 1,
    subSuper: 2,
    admin: 3,
    operation: 4,
  };

  return (
    <div className="main-div">
      {(role === "super" || role === "operation" || role === "subSuper") && (
        <div className="disable-header">
          <div className="disable-all">
            <button
              onClick={handleAllPayin}
              className="disable-all-btn"
              value={payinChecked ? 1 : 0}
              style={{
                backgroundColor: payinChecked ? "red" : "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {payinChecked ? "Disable Payin" : "Enable Payin"}
            </button>
          </div>

          <div className="disable-all">
            <button
              onClick={handleAllPayout}
              className="disable-all-btn"
              value={payoutChecked ? 1 : 0}
              style={{
                backgroundColor: payoutChecked ? "red" : "green",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              {payoutChecked ? "Disable Payout" : "Enable Payout"}
            </button>
          </div>
        </div>
      )}

      <div
        className="table-main-div"
        ref={tableDivRef}
        style={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <table className="table-user-management">
          <thead className="table-user-header">
            <tr>
              <td>
                <p className="user-table-head">S.No</p>
              </td>
              <td>
                <p className="user-table-head">User Email</p>
              </td>
              <td>
                <p className="user-table-head">Name</p>
              </td>
              {(role == "super" ||
                role == "operation" ||
                role == "subSuper") && (
                <td className="filter-pos">
                  <div className="data-icon">
                    <p className="user-table-head-report">Role</p>
                    <FaFilter
                      style={{
                        marginRight: "0.2rem",
                        width: "1rem",
                        height: "1rem",
                        cursor: "pointer",
                      }}
                      onMouseEnter={() => setRoles(true)}
                      onMouseLeave={() => setRoles(false)}
                    />
                  </div>
                  {roles && (
                    <div
                      className="transfer-mode"
                      onMouseEnter={() => setRoles(true)}
                      onMouseLeave={() => setRoles(false)}
                    >
                      <p
                        onClick={() => {
                          setSelectedRoleName("All");
                          setRoles(false);
                        }}
                      >
                        All
                      </p>
                      {roleOptions.map((r) => (
                        <p
                          key={r.id}
                          onClick={() => {
                            setSelectedRoleName(r.role);
                            setRoles(false);
                          }}
                        >
                          {r.role}
                        </p>
                      ))}
                    </div>
                  )}
                </td>
              )}

              {role == "admin" && role == "subAdmin" && (
                <>
                  <td>
                    <p className="user-table-head">Role</p>
                  </td>
                </>
              )}
              {role !== "admin" && role !== "subAdmin" && (
                <>
                  <td>
                    <p className="user-table-head">Payin ProviderID</p>
                  </td>
                  <td>
                    <p className="user-table-head">Payout ProviderID</p>
                  </td>
                  <td>
                    <p className="user-table-head">Payin</p>
                  </td>
                  <td>
                    <p className="user-table-head">Payout</p>
                  </td>
                </>
              )}
              <td>
                <p className="user-table-head">User</p>
              </td>
              {role !== "admin" && role !== "subAdmin" && (
                <>
                  <td>
                    <p className="user-table-head">VPA</p>
                  </td>
                  <td>
                    <p className="user-table-head">IP</p>
                  </td>
                  <td>
                    <p className="user-table-head">Auto Switch Payin</p>
                  </td>
                  <td>
                    <p className="user-table-head">Auto Switch Payout</p>
                  </td>
                </>
              )}
              <td>
                <p className="user-table-head">Status</p>
              </td>
              <td>
                <p className="user-table-head">Update</p>
              </td>
              <td>
                <p className="user-table-head">View</p>
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredItems &&
              filteredItems.length > 0 &&
              [...filteredItems]
                .sort((a, b) => {
                  const roleA = rolePriority[a.role] ?? 99;
                  const roleB = rolePriority[b.role] ?? 99;
                  return roleA - roleB;
                })
                .map((item, i) => {
                  return (
                    <tr key={i} className="table-user-data">
                      <td>
                        <p className="user-table-head">{i + 1}</p>
                      </td>
                      <td>
                        <p className="user-table-head">{item.email}</p>
                      </td>
                      <td>
                        <p className="user-table-head user-table-name">
                          {item.role === "admin"
                            ? item.alias || item.id
                            : item.alias || item.name}
                        </p>
                      </td>
                      <td>
                        <p className="user-table-head">{item.role}</p>
                      </td>
                      {role !== "admin" && role !== "subAdmin" && (
                        <>
                          <td>
                            {(() => {
                              const provider = providerOptions.find(
                                (option) => option.id === item.payinProviderID,
                              );

                              return (
                                <p
                                  className="user-table-head"
                                  style={{
                                    color: provider?.isActive ? "black" : "red",
                                  }}
                                >
                                  {provider
                                    ? `${provider.providerName} - ${provider.orgName}`
                                    : "N/A"}
                                </p>
                              );
                            })()}
                          </td>

                          <td>
                            {(() => {
                              const provider = providerOptions.find(
                                (option) => option.id === item.payoutProviderID,
                              );

                              return (
                                <p
                                  className="user-table-head user-table-payoutProviderID"
                                  style={{
                                    color: provider?.isActive ? "black" : "red",
                                  }}
                                >
                                  {provider
                                    ? `${provider.providerName} - ${provider.orgName}`
                                    : "N/A"}
                                </p>
                              );
                            })()}
                          </td>
                          <td>
                            {item.role !== "admin" &&
                            item.role !== "subAdmin" ? (
                              "N/A"
                            ) : (
                              <Switch
                                checked={item.status === 1 || item.status === 3}
                                onChange={() =>
                                  handleConfirmModal(
                                    `Are you sure you want to ${
                                      item.status === 1 || item.status === 3
                                        ? "disable"
                                        : "enable"
                                    } payin for ${item.alias || item.id}?`,
                                    () => handlePayinChange(item),
                                  )
                                }
                              />
                            )}
                          </td>

                          <td>
                            {item.role !== "admin" &&
                            item.role !== "subAdmin" ? (
                              "N/A"
                            ) : (
                              <Switch
                                checked={item.status === 1 || item.status === 2}
                                onChange={() =>
                                  handleConfirmModal(
                                    `Are you sure you want to ${
                                      item.status === 1 || item.status === 2
                                        ? "disable"
                                        : "enable"
                                    } payout for ${
                                      item.role === "admin"
                                        ? item.alias || item.id
                                        : item.alias || item.name
                                    }?`,
                                    () => handlePayoutChange(item),
                                  )
                                }
                              />
                            )}
                          </td>
                        </>
                      )}
                      <td>
                        <Switch
                          checked={item.status !== 0}
                          onChange={() =>
                            handleConfirmModal(
                              `Are you sure you want to ${
                                item.status !== 0 ? "disable" : "enable"
                              } user ${
                                item.role === "admin"
                                  ? item.alias || item.id
                                  : item.alias || item.name
                              }?`,
                              () => handleUserChange(item),
                            )
                          }
                        />
                      </td>
                      {role !== "admin" && role !== "subAdmin" && (
                        <>
                          <td>
                            <Switch
                              checked={item.validateVpa == 1}
                              onChange={() =>
                                handleConfirmModal(
                                  `Are you sure you want to ${
                                    item.validateVpa != 1 ? "disable" : "enable"
                                  } validate VPA?`,
                                  () => handleVPAChange(item),
                                )
                              }
                            />
                          </td>
                          <td>
                            <Switch
                              checked={item.ipRequired == 1}
                              onChange={() =>
                                handleConfirmModal(
                                  `Are you sure you want to ${
                                    item.ipRequired == 1 ? "disable" : "enable"
                                  } IP Whitelisting?`,
                                  () => handleIPWhitelisting(item),
                                )
                              }
                            />
                          </td>
                          <td>
                            <Switch
                              checked={!!item.autoSwitch}
                              onChange={() =>
                                handleConfirmModal(
                                  `Are you sure you want to ${
                                    item.autoSwitch ? "disable" : "enable"
                                  } Auto Switch Payin?`,
                                  () => handleAutoSwitch(item),
                                )
                              }
                            />
                          </td>
                          <td>
                            <Switch
                              checked={!!item.autoSwitchPayout}
                              onChange={() =>
                                handleConfirmModal(
                                  `Are you sure you want to ${
                                    item.autoSwitchPayout ? "disable" : "enable"
                                  } Auto Switch Payout?`,
                                  () => handleAutoSwitchPayout(item),
                                )
                              }
                            />
                          </td>
                        </>
                      )}
                      <td>
                        <p className="user-table-head status-table">
                          {item.status == 0 ? (
                            <span className="red-dot"></span>
                          ) : (
                            <span className="green-dot"></span>
                          )}
                          {item.status === 0 ? (
                            <p className="inactive">Inactive</p>
                          ) : item.status === 1 ? (
                            <p className="active">Active</p>
                          ) : item.status === 2 ? (
                            <p className="active">Payin Disabled</p>
                          ) : item.status === 3 ? (
                            <p className="active">Payout Disabled</p>
                          ) : item.status === 4 ? (
                            <p className="active">Payin & Payout Disabled</p>
                          ) : null}
                        </p>
                      </td>
                      {item.role !== "super" ? (
                        <td>
                          <p
                            className="user-table-head"
                            onClick={() => updateFunction(item, setFormData)}
                          >
                            <CiEdit
                              style={{
                                width: "1.2rem",
                                height: "1.2rem",
                                cursor: "pointer",
                              }}
                            />
                          </p>
                        </td>
                      ) : (
                        <p></p>
                      )}
                      <td>
                        <p
                          className="user-table-head"
                          onClick={() =>
                            viewFunction(item, setFormData, setIsModalOpen)
                          }
                        >
                          <MdRemoveRedEye
                            style={{
                              width: "1.2rem",
                              height: "1.2rem",
                              cursor: "pointer",
                            }}
                          />
                        </p>
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
        {isModalOpen && (
          <Modal
            onClose={handleModalClose}
            onSubmit={(updatedFormData) => {
              handleUpdateSubmit(updatedFormData, formData);
            }}
            initialFormData={formData}
            isUpdating={true}
            isLoading={isLoading}
            role={role}
          />
        )}
        {confirmModalOpen && (
          <ConfirmModal
            text={confirmText}
            onConfirm={confirmAndClose}
            onCancel={() => setConfirmModalOpen(false)}
          />
        )}

        {isViewModalOpen && (
          <ViewModal onClose={handleModalClose} formData={formData} />
        )}
        {isEnableUserPromptOpen && (
          <Prompt
            open={() => setIsEnableUserPromptOpen(false)}
            onClose={() => setIsEnableUserPromptOpen(false)}
            onConfirm={() => handleEnableAction(formData, fetchUsers)}
            text={`Are you sure you want to ${
              formData.status === 2
                ? "enable payin"
                : formData.status === 3
                  ? "enable payout"
                  : "enable user"
            }: ${formData?.asdsad}?`}
          />
        )}
        {isDisableUserPromptOpen && (
          <Prompt
            open={() => setIsDisableUserPromptOpen(false)}
            onClose={() => setIsDisableUserPromptOpen(false)}
            onConfirm={() => handleDisableAction(formData, fetchUsers)}
            text={`Are you sure you want to ${
              formData.status === 2
                ? "disable payin"
                : formData.status === 3
                  ? "disable payout"
                  : "disable user"
            }: ${formData?.akjds}?`}
          />
        )}
        {disableAllUserPayinPrompt && (
          <Prompt
            open={() => setDisableAllUserPayinPrompt(false)}
            onClose={() => setDisableAllUserPayinPrompt(false)}
            onConfirm={() => handleDisableAllPayinAction(formData, fetchUsers)}
            text={"Are you sure you want to disable payin for all users?"}
          />
        )}
        {enableAllUserPayinPrompt && (
          <Prompt
            open={() => setEnableAllUserPayinPrompt(false)}
            onClose={() => setEnableAllUserPayinPrompt(false)}
            onConfirm={() => handleEnableAllPayinAction(formData, fetchUsers)}
            text={"Are you sure you want to enable payin for all users?"}
          />
        )}
        {disableAllUserPayoutPrompt && (
          <Prompt
            open={() => setDisableAllUserPayoutPrompt(false)}
            onClose={() => setDisableAllUserPayoutPrompt(false)}
            onConfirm={() => handleDisableAllPayoutAction(formData, fetchUsers)}
            text={"Are you sure you want to disable payout for all users?"}
          />
        )}

        {enableAllUserPayoutPrompt && (
          <Prompt
            open={() => setEnableAllUserPayoutPrompt(false)}
            onClose={() => setEnableAllUserPayoutPrompt(false)}
            onConfirm={() => handleEnableAllPayoutAction(formData, fetchUsers)}
            text={"Are you sure you want to enable payout for all users?"}
          />
        )}

        {disableAllUsersPrompt && (
          <Prompt
            open={() => setDisableAllUsersPrompt(false)}
            onClose={() => setDisableAllUsersPrompt(false)}
            onConfirm={() => handleDisableAllAction(formData, fetchUsers)}
            text={"Are you sure you want to disable all users?"}
          />
        )}

        {enableAllUsersPrompt && (
          <Prompt
            open={() => setEnableAllUsersPrompt(false)}
            onClose={() => setEnableAllUsersPrompt(false)}
            onConfirm={() => handleEnableAllAction(formData, fetchUsers)}
            text={"Are you sure you want to enable all users?"}
          />
        )}

        {isFetching && hasMore && (
          <div style={{ textAlign: "center", padding: "15px" }}>
            Loading more users...
          </div>
        )}
        {!hasMore && (
          <div style={{ textAlign: "center", padding: "15px" }}>
            No more users
          </div>
        )}
      </div>
    </div>
  );
}

export default React.memo(UserManageTable);
